var _path, _path2, _path3, _path4, _defs;
const _excluded = ["svgRef"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
const SvgCorrectGray = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 9.99992C16.6667 13.4999 13.9167 16.4166 10.4167 16.6666C10.25 16.6666 10.0834 16.6666 10 16.6666C6.33337 16.6666 3.33337 13.6666 3.33337 9.99992C3.33337 6.33325 6.33337 3.33325 10 3.33325C10.1667 3.33325 10.3334 3.33325 10.4167 3.33325C13.9167 3.58325 16.6667 6.49992 16.6667 9.99992Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 9.99992C16.6667 13.4999 13.9167 16.4166 10.4167 16.6666C10.25 16.6666 10.0834 16.6666 10 16.6666C6.33337 16.6666 3.33337 13.6666 3.33337 9.99992C3.33337 6.33325 6.33337 3.33325 10 3.33325C10.1667 3.33325 10.3334 3.33325 10.4167 3.33325C13.9167 3.58325 16.6667 6.49992 16.6667 9.99992Z",
    fill: "#D8D8D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08337 10.0002L9.00004 11.9169",
    stroke: "#B6B6B6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9168 8.0835L9.00012 11.9168",
    stroke: "#B6B6B6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 3.33337,
    y1: 9.99992,
    x2: 16.6667,
    y2: 9.99992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39BC4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#1FA626"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCorrectGray, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/CorrectGray.d82ff32f.svg";
export { ForwardRef as ReactComponent };